(function () {
  if (window.__readMoreHandlerAttached) return; // Prevent duplicate setup
  window.__readMoreHandlerAttached = true;

  document.addEventListener('DOMContentLoaded', function () {
    document.body.addEventListener('click', function (e) {
      if (e.target && e.target.id === 'read_more_btn') {
        const content = document.getElementById('read_more_content');
        if (content) {
          e.preventDefault();
          e.target.style.display = 'none';
          content.style.display = 'inline';
        }
      }
    });
  });
})();
